import React, {useState} from 'react'
import {Container, FormControl, Tabs, Tab} from 'react-bootstrap'
import './style.css'
import Buku from './categoricomp/buku'
import Makanan from './categoricomp/makanan'
import Minuman from './categoricomp/minuman'
import Pakaian from './categoricomp/pakaian'

export default function Produk(props) {
    const [actived, setActived] = useState(false)

    const toggle = i => {
        if(actived === i) {
           return setActived(null)
        }
        setActived(i)
    }
    return (
        <Container className="category-main">
                <h3>Kategori</h3>
                <FormControl className="input" placeholder="Cari di Halaman Kategori ..." />
                <div className="urutan">
                    <h6>Urutkan</h6>
                    {
                        Urutan.map((data, i) => {
                            return (
                                <button key={i} onClick={_ => toggle(i)} className={actived === i ? "active-button" : null} type="butuon">{data.nama}</button>
                            )
                        })
                    }
                </div>
                <Tabs className="link">
                    {
                        Links.map((item, i) => {
                            return (
                                <Tab eventKey={item.eventKey} key={i} title={item.title}>
                                    { i === 0 ? <Buku to={props.tolink} /> :null }
                                    { i === 1 ? <Makanan /> :null }
                                    { i === 2 ? <Minuman /> :null }
                                    { i === 3 ? <Pakaian /> :null }
                                </Tab>
                            )
                        })
                    }
                </Tabs>
            </Container>
    )
}

const Urutan = [
    {nama:"Terpopuler"},
    {nama:"Nama A-Z"},
    {nama:"Nama A-Z"}
]

const Links = [
    {title:"Buku", eventKey:"buku", buku:"Buku"},
    {title:"Makanan", eventKey:"makanan"},
    {title:"Minuman", eventKey:"minuman"},
    {title:"Pakaian", eventKey:"pakaian"}
]
